import { defineComponent } from 'vue';

export default defineComponent({
  // component options here
  name: 'DlContainer',
  props: {
    // define your props
  },
  setup(props, { slots, emit }) {
    // composition logic here
    return {};
  }
});
